import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { clinicalSpecialty } from '../mockData/clinical-specialty-data';

const ClinicalSpecialtyApi = [
  rest.get(`${API_ROOT}clinical-specialities`, (req, res, ctx) => res(ctx.json(clinicalSpecialty))),
  rest.get(`${API_ROOT}clinical-specialities/${clinicalSpecialty[0].id}`, (req, res, ctx) => res(ctx.json(clinicalSpecialty[0]))),
  rest.put(`${API_ROOT}clinical-specialities/${clinicalSpecialty[0].id}`, (req, res, ctx) => res(ctx.json(clinicalSpecialty[0]))),
  rest.post(`${API_ROOT}clinical-specialities`, (req, res, ctx) => res(ctx.json(clinicalSpecialty[1]))),
  rest.delete(`${API_ROOT}clinical-specialities/${clinicalSpecialty[0].id}`, (req, res, ctx) => res(ctx.json(clinicalSpecialty[0]))),
];

export default ClinicalSpecialtyApi;
